import React from 'react';
import { Asset } from 'contentful';

import { IFullwidthHero20Fields } from '../../../../types/contentful';

import { getImageData } from '../../../utils/contentful';

import { Text } from '../../Text';
import { Box } from '../../Box';
import { Column, Layout } from '../../Layout';
import CtaWidget from '../../CtaWidget';
import { VideoPlayer } from '../../VideoPlayer';
import PrivacyPolicyDisclaimer from '../PrivacyPolicyDisclaimer';

import {
  DesktopImage,
  DesktopBlockContainer,
  SubheadText,
  SpacerColumn,
  RelativeBox
} from '../styles';

export default function DesktopView({
  headingText,
  useLightHeadingText,
  subheadingText,
  subheadingSize,
  useLightSubheadingText,
  fullwidthDesktopImage,
  privacyPolicyDisclaimer,
  displayPrivacyPolicyIcon,
  desktopCta,
  videoModule
}: IFullwidthHero20Fields) {
  const visibility = fullwidthDesktopImage ? 'visible' : 'hidden';

  return (
    <DesktopBlockContainer
      marginTop={{
        0: 'blockMarginY',
        tablet: 'blockMarginY_tablet'
      }}
      marginBottom={{
        0: 'blockMarginY',
        tablet: '3xl'
      }}
      revealOnScroll={false}
      data-blockid="fullwidth-hero-desktop"
    >
      <Layout gutter={{ tablet: 'collapsibleVert' }} marginTop="s">
        <SpacerColumn size={1} />
        <Column
          size={{ tablet: 5 }}
          flexDirection="column"
          justifyContent="center"
        >
          <Text
            as="h1"
            fontWeight="h1"
            fontSize={{ 0: 'h1_0', desktop: 'h1_tablet' }}
            colour={useLightHeadingText ? 'white' : 'defaultText'}
            textAlign="left"
            marginTop={0}
            marginBottom="m"
            data-testid="fullwidth-hero-headline-desktop"
            dangerouslySetInnerHTML={{
              __html: headingText || ''
            }}
          />
          <SubheadText
            as="h2"
            data-testid="fullwidth-hero-subhead-desktop"
            fontWeight="p"
            subheadingSize={subheadingSize || '1.75'}
            colour={useLightSubheadingText ? 'white' : 'defaultText'}
            textAlign="left"
            marginTop={0}
            marginBottom="ml"
          >
            {subheadingText}
          </SubheadText>
          {desktopCta && (
            <CtaWidget
              {...desktopCta?.fields}
              sysId={desktopCta?.sys?.contentType?.sys?.id}
              id="desktop-nav-cta"
              module="Hero"
              height={56}
              isMobile={false}
            />
          )}
          {privacyPolicyDisclaimer && (
            <Box marginTop="ml">
              <PrivacyPolicyDisclaimer
                privacyPolicyDisclaimer={privacyPolicyDisclaimer}
                displayPrivacyPolicyIcon={displayPrivacyPolicyIcon}
              />
            </Box>
          )}
        </Column>
        <Column size={{ tablet: 7, desktop: 6 }}>
          {videoModule?.fields?.vimeoId ? (
            <VideoPlayer {...videoModule?.fields} />
          ) : (
            <RelativeBox flex="1">
              <DesktopImage
                {...getImageData(fullwidthDesktopImage as Asset)}
                visibility={visibility}
                loading="eager"
                heroImage={true}
              />
            </RelativeBox>
          )}
        </Column>
      </Layout>
    </DesktopBlockContainer>
  );
}
